import React from 'react';
import {Typography} from '@mui/material';
import TxList from "../../components/TxList";
import useLatestTxs from "../../queries/useLatestTxs";

const LatestTransactionsContent = ({allowExpand = false}) => {
    const latestTxsQuery = useLatestTxs();
    if (latestTxsQuery.isLoading) {
        return <Typography variant="body1">Loading...</Typography>;
    }
    if (latestTxsQuery.isError) {
        return <Typography variant="body1">Request failed.</Typography>;
    }

    return <TxList data={latestTxsQuery.data.payload} allowExpand={allowExpand}/>;
};


export default LatestTransactionsContent;
